import { useQuery } from "@tanstack/react-query";
import type { UserWorkspacesData } from "@modules/auth/select-workspace/types";
import { getUserWorkspaces } from "@modules/auth/select-workspace/services";

const DEV_MOCK = false;

export function useGetUserWorkspaces() {
  if (DEV_MOCK) {
    console.warn("[useGetUserWorkspaces stub]");
    return { data: undefined, isLoading: false, isPending: false, isError: false, refetch: () => {} };
  }

  return useQuery<UserWorkspacesData>({
    queryKey: ["user-workspaces"],
    queryFn: ({ signal }) => getUserWorkspaces(signal),
    retry: 1,
  });
}
